define('views/user/forgotpassword/resetpassword/resetpassword',["backbone",
    "text!views/user/forgotpassword/resetpassword/resetpassword.html",
    "views/_base/baseview",
    "models/shared/lookups/systext",
    "models/user/resetpassword/resetpassword",
    "css!vendors/jquery/tooltipster/tooltipster.css"
], function (Backbone, Template, BaseView, SystemText, ResetPassword, SecurityQuestion,SecurityQuestionView) {
    "use strict";

    return BaseView.extend({
        template: _.template(Template),
        tagName: "form",
        id: "resetPassword",
        isRender: true,
        needsAuth: false,
        activityIndicator: false,
        events: {
            "click #resetSaveBtn": "submitPassword"
        },
        initialize: function (options) {
            options = options || {};
            this.FPG = options.GUID;
            this.model = new ResetPassword({ FPG: this.FPG });
            Backbone.Validation.bind(this, {
                valid: function (view, attr) {
                    var item = view.$("[name=" + attr + "]");
                    item.removeClass("hasError");
                    $(item).tooltipster();
                    $(item).tooltipster("hide");
                },
                invalid: function (view, attr, error) {
                    if (this.xhr == null || this.xhr.status != 200) {
                        var item = view.$("[name=" + attr + "]");
                        item.addClass("hasError");
                        $(item).tooltipster();
                        $(item).tooltipster("content", error);
                        $(item).tooltipster("show");
                    }
                }
            });

            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },
        render: function () {
            this.$el.html(this.template());
            this.$("div.spinner").addClass("hidden");
            return this;
        },
        loadData:function(){            
        },
        submitPassword: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var success = false;

            var that = this;
            

            var data = this.$el.serializeObject();
            data.GUID = that.FPG;
            data.Password = data.Password;
            data.PasswordConfirm = data.PasswordConfirm;
            this.model.set(data);

            if (this.model.isValid(true)) {

                data.Password = encrypt(data.Password);
                data.PasswordConfirm = encrypt(data.PasswordConfirm);
                this.model.set(data);
                that.$("div.spinner").removeClass("hidden");
                this.$("#resetSaveBtn").attr('disabled', true);
                this.model.save(that.model.attributes, {
                    success: function (resp) {
                        that.$("div.spinner").addClass("hidden");
                        that.$("#resetSaveBtn").attr('disabled', false);
                        pfdialog.alert({ context: this, Body: "Your password has been changed successfully.  You may now log in with your new password.", Title: "Password Changed" });                        
                        pf.navigate("login");
                    },
                    error: function (resp) {
                        that.$("div.spinner").addClass("hidden");
                        that.$("#resetSaveBtn").attr('disabled', false);
                        pfdialog.error({ context: this, Body: "Unable to reset password. Please try again or resubmit your request to reset your password.", Title: "Unable to Reset Password" });

                    },
                    complete: function (resp) {
                        switch (resp.status) {
                            case 200:
                                that.$("div.spinner").addClass("hidden");
                                that.$("#resetSaveBtn").attr('disabled', false);
                                pfdialog.alert({ context: this, Body: "Your password has been changed successfully.  You may now log in with your new password.", Title: "Password Changed" });                                
                                pf.navigate("login");
                                break;
                        }
                    }

                });
            }

            return success;
        },
        close: function () {
        }
    });
});
